export const TABLE_NAMES = {
  TEAM_MEMBERS_LIST: "visitor-team-members-list",
  CUSTOMER_LIST: "customer",
  UNKNOWN_LIST: "unknown-list",
};

export const SESSION_KEYS = {
  CAN_ADD: "canAdd",
  CAN_EDIT: "canEdit",
  CAN_VIEW: "canView",
  CAN_DELETE: "canDelete",
  TOKEN: "token",
};

export const PAGE_URLS = {
  TEAM_MEMBERS: "/customer/team",
  CUSTOMER: "/customer/list",
  UNKNOWN: "/unknown",
  CUSTOMER_CONTACT: "/customer/customer-contact",
};

export enum TABLE_COLUMN_TYPE {
  TEXT = "text",
  DATE = "date",
  CUSTOM = "custom",
  CUSTOM_DATE = "custom_date",
  DATE_TIME = "date_time",
  LIST = "list",
  ACTION = "action",
}

export enum COLUMN_LIST_TYPE {
  labelList = "TM_LTLList",
}

export interface Int_TableColumn {
  title: string;
  dataIndex: number;
  sortByKey: string;
  viewKey: string;
  subKey?: string;
  type: TABLE_COLUMN_TYPE;
  listType?: COLUMN_LIST_TYPE;
  headerAlign: "center" | "start" | "end";
  customHeaderClass?: string;
  bodyAlign: "center" | "start" | "end";
  customBodyClass?: string;
  width?: number;
  onClick?: (row: any) => void;
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  isSortable?: boolean;
  isSelected?: boolean;
}

export interface Int_Insert_contact {
  CTID?: number;
  Name: string;
  Phone: string;
  UID: number;
  IsActive?: boolean;
  PhonePreFix: string;
  numberField: { number: string; dialCode: string };
}
